import React, { useContext, useState } from "react";
import {
  Form,
  Input,
} from "reactstrap";
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';
import { toast } from "react-toastify";
import validator from "validator";
import Axios from "axios";
import { UserContext } from "../../context/UserContext";
import { Redirect, Link } from "react-router-dom";
const Registration = () => {
  const context = useContext(UserContext);
  const [email, setEmail] = useState(context.user?.otpemail);
  const [firstname, setFirstName] = useState("");
  const [lastaname, setLastName] = useState("");
  const [password, setPassword] = useState("");
  // const [password,setPassword]=useState('')
  console.log(setEmail)
  const logindata = {
    email: "",
    firstname: "",
    lastaname: "",
    password: "",
  };
  if(context.user===null)
  {
    toast.error("Seems that you have refresh Page,try again", {
      position: toast.POSITION.BOTTOM_LEFT,
    });
  }
  const handleRegSubmit = (e) => {
    e.preventDefault();
    registeruser();
  };
  const registeruser = async () => {
    if (firstname === "" || lastaname === "" || password === "") {
      toast.error("Enter valid details", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    } else if (!validator.isAlpha(firstname)) {
      toast.error("Enter Valid FirstName", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    } else if (!validator.isAlpha(lastaname)) {
      toast.error("Enter Valid FirstName", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }
    else if(password.length<=7)
    {
      toast.error("Password length must be greater than or equals to 8", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }
    logindata.email = email;
    logindata.password = password;
    logindata.firstname = firstname;
    logindata.lastaname = lastaname;
    await Axios.post("Login/register", { logindata })
      .then((res) => {
        if (res.data.status === "200" && res.data.exist==="true") {
          toast.error("Already Register !!!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
        }
        else if (res.data.status === "200" && res.data.exist==="false") {
          toast.success("Registration successful..!!", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          context.setUser({email:res.data.email})
        }
        throw res;
      })
      .then((resJson) => {})
      .catch((error) => {
        console.log("error123", error);
      });
  };
  if(context.user?.email)
  {
	return<Redirect to="/Signin"/>
  }
  else if(context.user===null)
  {
    return<Redirect to="/Signup"/>
  }
  return (
    <div>
      <div class="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-5 mx-auto">
        <div class="">
          <div class="row d-flex">
            <div class="col-lg-6">
              <div class="card1 pb-5">
                <div class="row">  </div>
                <div class="row px-3 justify-content-center mt-4 mb-5 border-line-left">  <img alt="executive2" width="" src="/assets/images/ban-image.png" /> </div>
              </div>
            </div>
            <div class="col-lg-6"><br />
              <div class="card2 card border-0 px-4 py-5">
                <div class="row px-3 mb-4">
                  <div class="line-forgot"></div> <span class="or-forgot text-center"> Verify OTP</span>
                  <div class="line-forgot"></div>
                </div>
                <Form onSubmit={handleRegSubmit}>
                  <div class="row px-3 mb-3"> <label class="mb-1">
                    <h6 class="mb-0 text-sm">username</h6>
                  </label>
                    <Input
                      type="text"
                      name="emai"
                      id="emai"
                      value={email}
                      disabled={true}
                    />
                  </div>
                  <div class="row px-3 mb-3"> <label class="mb-1">
                    <h6 class="mb-0 text-sm">FirstName</h6>
                  </label>
                      <Input
                        type="text"
                        name="firstname"
                        id="firstname"
                        placeholder="Enter your FirstName"
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                  </div>

                  <div class="row px-3 mb-3"> <label class="mb-1">
                    <h6 class="mb-0 text-sm">LastName</h6>
                  </label>
                    <Input
                        type="lastname"
                        name="lastname"
                        id="lastname"
                        placeholder="Enter your LastName"
                        onChange={(e) => setLastName(e.target.value)}
                    />
                  </div>
                  
                  <div class="row px-3 mb-3"> <label class="mb-1">
                    <h6 class="mb-0 text-sm">Password</h6>
                  </label>
                      <Input
                        type="password"
                        name="password"
                        id="password"
                        placeholder="your password here"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                  </div>
                  <div class="row mb-3 px-3"> {email ? <button type="submit" class="btn btn-blue text-center">  Verify OTP</button> : "Invalid Request"}</div>
                </Form>
                <div class="row mb-4 px-3"> <small class="font-weight-bold">Already Register?<Link tag={Link} class="text-danger " to="/Signin"><u>Sign in</u></Link> </small> </div>
                <div class="row px-3 ">
                  <div class="line-follow"></div> <small class="or-follow text-center">Follow us</small>
                  <div class="line-follow"></div>
                </div>
                <div class="row mr-l">
                  <div class="facebook text-center mr-3">{// eslint-disable-next-line
                  } <a href={'https://www.facebook.com/eduplusnow/'} ><FacebookIcon /></a>
                  </div>
                  <div class="twitter text-center mr-3">{// eslint-disable-next-line
                  } <a href={'href="https://www.youtube.com/channel/UCtkn64AR1Qrmk2Z-o0bzzsA"'} ><YouTubeIcon /></a>
                  </div>
                  <div class="linkedin text-center mr-3">{// eslint-disable-next-line
                  } <a href={'https://www.linkedin.com/company/edu-plus-now/'} >
                      <LinkedInIcon /></a>
                  </div>
                  <div class="insta text-center mr-3">{// eslint-disable-next-line
                  } <a href={'https://www.instagram.com/eduplusnow/'} >
                      <InstagramIcon /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Registration;
